import Vue from 'vue'
import Router from 'vue-router'
import OrderForm from '../views/OrderForm.vue'
import HistoryOrders from '../views/HistoryOrders.vue'
import OrderDashboard from '../views/OrderDashboard.vue'
import LoginPage from '../views/LoginPage.vue'
import AdminDashboard from '../views/AdminDashboard.vue'
import AccountManagement from '../views/AccountManagement.vue'
import ConfigManagement from '../views/ConfigManagement.vue'
import ProductManagement from '../views/ProductManagement.vue'
import AgentAccountManagement from '../views/AgentAccountManagement.vue'
import store from '../store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
        path: '/login',
        name: 'LoginPage',
        component: LoginPage,
        meta: {
          requiresAuth: false
        }
      },
    {
      path: '/',
      name: 'OrderDashboard',
      component: OrderDashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order-form',
      name: 'OrderForm',
      component: OrderForm,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/history-orders',
      name: 'HistoryOrders',
      component: HistoryOrders,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin-dashboard',
      name: 'AdminDashboard',
      component: AdminDashboard,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: '/account-management',
      name: 'AccountManagement',
      component: AccountManagement,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/config-management',
      name: 'ConfigManagement',
      component: ConfigManagement,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: '/product-management',
      name: 'ProductManagement',
      component: ProductManagement,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: '/agent-accounts',
      name: 'AgentAccountManagement',
      component: AgentAccountManagement,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }
  ]
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 检查页面是否需要登录
  if (to.meta.requiresAuth) {
    try {
      // 检查用户是否已登录
      const isLoggedIn = store.getters['user/isLoggedIn']
      if (isLoggedIn) {
        // 检查是否需要管理员权限
        if (to.meta.requiresAdmin) {
          const userInfo = store.getters['user/userInfo']
          if (userInfo && userInfo.role === 'admin') {
            next()
          } else {
            // 不是管理员，跳转到首页
            next({ path: '/' })
            alert('您没有权限访问此页面')
          }
        } else {
          next()
        }
      } else {
        // 未登录，跳转到登录页面
        next({ path: '/login' })
      }
    } catch (error) {
      // 如果store还未初始化，先跳转到登录页面
      next({ path: '/login' })
    }
  } else {
    // 不需要登录的页面，直接放行
    next()
  }
})

export default router